<template>
  <div class="count-down-container" v-if="regEndTime">
    <p class="cdText">{{ cdText }}</p>
    <div class="count-down-box">
      <p class="cdSubText">{{ cdSubText }}</p>
      <div class="cbShowTime">
        <p>{{ getCountDown.days || "00" }}</p>
        <span>天</span>
        <p>{{ getCountDown.hours || "00" }}</p>
        <span>:</span>
        <p>{{ getCountDown.minutes || "00" }}</p>
        <span>:</span>
        <p>{{ getCountDown.seconds || "00" }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cdText: {
      type: String,
    },
    cdSubText: {
      type: String,
    },
    regEndTime: {
      type: Number,
    },
  },
  data() {
    return {
      timer: null,
      distance: 0,
      getCountDown: {},
      hasChange: 1,
    };
  },
  mounted() {
    this.timer = setInterval(this.getFullTime(), 1000);
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  computed: {
    countDown() {
      const endTime = +this.regEndTime * 1000;
      return endTime;
    },
  },
  methods: {
    pad(num) {
      return ("00" + num).slice(-2);
    },
    getFullTime() {
      const now = new Date().getTime();
      const dis = this.countDown - now;
      if (dis < 0) {
        this.hasChange = 2;
        clearInterval(this.timer);
        this.$emit("handleCountDown", this.hasChange);
        return;
      }

      const getCountDown = {
        days: this.pad(Math.floor(dis / (1000 * 60 * 60 * 24))),
        hours: this.pad(
          Math.floor((dis % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        ),
        minutes: this.pad(Math.floor((dis % (1000 * 60 * 60)) / (1000 * 60))),
        seconds: this.pad(Math.floor((dis % (1000 * 60)) / 1000)),
      };
      this.getCountDown = getCountDown;
      return this.getFullTime;
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/mixin.less";
.count-down-container {
  .self-flex(space-between);
  align-items: center;
  margin: 10px auto 5px;
  padding: 3px 8px;
  background-color: var(--el-color-primary-light-8);
  border-radius: 2px;
  .cdText {
    font-size: 16px;
    color: var(--el-color-primary);
    letter-spacing: 1px;
  }
  .count-down-box {
    .self-flex(right);
    align-items: center;
    .cdSubText {
      font-size: 14px;
      color: var(--000);
    }
    .cbShowTime {
      .self-flex();
      align-items: center;
      font-size: 16px;
      p {
        color: var(--fff);
        padding: 2px 3px;
        background-color: var(--el-color-primary);
        border-radius: 5px;
        margin: 0 3px;
        width: 26px;
        text-align: center;
        &:last-child {
          margin-right: 0;
        }
      }
      span {
        font-size: 14px;
        color: var(--000);
      }
    }
  }
}
</style>